import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import {
  ACTION_INIT_EXCHANGE_RATES_FOR_EUR__REQUEST,
  ACTION_INIT_EXCHANGE_RATES_FOR_EUR__SUCCESS,
  ACTION_INIT_EXCHANGE_RATES_FOR_EUR__FAIL,
} from '../actionTypes/exchangeRatesForEur';


const actionInitExchangeRatesForEurRequestSuccess = result => ({
  type: ACTION_INIT_EXCHANGE_RATES_FOR_EUR__SUCCESS,
  payload: { result },
});

const actionInitExchangeRatesForEurRequestFail = error => ({
  type: ACTION_INIT_EXCHANGE_RATES_FOR_EUR__FAIL,
  payload: {
    error,
  },
});

export const actionInitExchangeRatesForEurRequest = () => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_INIT_EXCHANGE_RATES_FOR_EUR__REQUEST,
    });

    return apiClientHelper.get(
      '/rest/webmaster/init/exchange_rates_for_eur'
    ).then(
      result => {
        dispatch(actionInitExchangeRatesForEurRequestSuccess(result));
      },
      error => {
        dispatch(actionInitExchangeRatesForEurRequestFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
